import $ from 'jquery'


/* Panel
********************************************/

if ($('.js-panel').length) {
	$('.js-panel-toggle').on('click', function (e) {
		e.preventDefault();
		$(this).closest('.js-panel').toggleClass('is-open');
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.js-panel').length) {
			$('.js-panel').removeClass('is-open');
		}
	});
}
